module.exports = __webpack_public_path__ + "static/media/cog.c2c8fce0.svg";